// src/pdfjs-config.js
import { pdfjs } from 'react-pdf';

// Use the worker from the pdfjs-dist package
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

// Set the worker source
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default pdfjs;